import { useNavigate } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";
import { ArrowLeft, ClipboardCheck, ArrowRightLeft, ScanSearch } from "lucide-react";
import { useTranslation } from "../i18n";
import { isVisible, useHomeModuleVisibility, readUserRole } from "../components/helpers/homeModuleVisibility";
import "../styles/home.css";

// Stock Control hub — sits between Put Away and Pick Face. Groups the
// three stock-maintenance workflows behind one tile. Mirrors the
// pick-face submenu pattern (button cards -> navigate, back button to
// home). Per-card visibility uses the dot-pathed module keys so admins
// can hide individual workflows from Admin Settings.
const StockControlMenu = () => {
    usePageTitle("stock_control");
    const navigate = useNavigate();
    const { t } = useTranslation();

    const userData = window.localStorage.getItem("user");
    const userObject = userData !== null ? JSON.parse(userData) : { permissions: "", warehouse: "" };
    const role = readUserRole();
    const moduleMap = useHomeModuleVisibility(userObject.warehouse);
    const show = (key: string) => isVisible(moduleMap, key, role);

    return (
        <div className="page-data" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <div className="page-title-bar">
                <h1 className="page-title">{t("stock_control")}</h1>
                <button className="page-back-btn" onClick={() => navigate("/")}>
                    <ArrowLeft size={20} />
                </button>
            </div>
            <div className="home-grid">
                {show("stock_control.stock_check") && (
                    <button className="home-card home-card-red" onClick={() => navigate("/stock-control/stock-check")}>
                        <div className="home-card-icon"><ClipboardCheck size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("stock_check")}</div>
                    </button>
                )}
                {show("stock_control.move_stock") && (
                    <button className="home-card home-card-red" onClick={() => navigate("/stock-control/move-stock")}>
                        <div className="home-card-icon"><ArrowRightLeft size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("move_stock")}</div>
                    </button>
                )}
                {show("stock_control.sku_check") && (
                    <button className="home-card home-card-red" onClick={() => navigate("/stock-control/sku-check")}>
                        <div className="home-card-icon"><ScanSearch size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("sku_check")}</div>
                    </button>
                )}
            </div>
        </div>
    );
};

export default StockControlMenu;
